module.exports = __webpack_public_path__ + "assets/img/5_1155_big.036c6453.jpg";